
import React, { useState, useRef, useEffect, useLayoutEffect } from 'react';
import { Info, CloudUpload, X, ChevronDown, Search, Menu, Trash2, ChevronsUpDown, ChevronsDown, XCircle, ChevronRight, CircleCheck } from 'lucide-react';
import { useHistory, useParams } from "react-router-dom";
import Tooltip from '../addentities/Tooltip.js';
import { ReactSortable } from 'react-sortablejs';
import { createPortal } from 'react-dom';
import apiHelper from '../../apiHelper';
import CharacterLimitedTextarea from '../../components/CharacterLimitedTextarea';
import DiscardConfirmationModal from '../../components/DiscardConfirmationModal.js';
import UnsavedChangesPrompt from '../../components/UnsavedChangesPrompt.js';
const MAX_IMAGES = 5;

// Reference children options
const REFERENCE_CHILDREN = ['Brands', 'Categories', 'SPU', 'SKU'];

const REFERENCE_OPTIONS = {
  Brands: [
    { label: 'Apple', value: 'apple' },
    { label: 'Samsung', value: 'samsung' },
    { label: 'OnePlus', value: 'oneplus' },
    { label: 'Xiaomi', value: 'xiaomi' },
  ],
  Categories: [
    { label: 'Mobile', value: 'mobile' },
    { label: 'Tablet', value: 'tablet' },
    { label: 'Laptop', value: 'laptop' },
  ],
  SPU: [
    { label: 'iPhone 16', value: 'iphone-16' },
    { label: 'iPhone 16e', value: 'iphone-16e' },
    { label: 'iPhone 16 Pro Max', value: 'iphone-16pm' },
  ],
  SKU: [
    { label: 'iPhone 16 - Black-256GB-Wifi', value: 'sku-b256' },
    { label: 'iPhone 16 - Black-512GB-Wifi', value: 'sku-b512' },
    { label: 'iPhone 16 - Black-1TB-Wifi', value: 'sku-b1tb' },
  ],
};

{/* SHARED FUNCTION TO DISPLAY LABEL IN TWO LINES IF CONTAINS ' - ' */ }
const renderLabel = (label) => {
  const parts = label.split(' - ');
  if (parts.length === 2) {
    return (
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <span style={{ color: '#6C757D', fontSize: '12px', marginBottom: '5px' }}>{parts[0]}</span>
        <span style={{ fontSize: '14px' }}>{parts[1]}</span>
      </div>
    );
  }
  return label;
};


const VARIATION_OPTIONS = [
  { label: 'Black Titanium', value: 'Black Titanium' },
  { label: 'White Titanium', value: 'White Titanium' },
  { label: 'Desert Titanium', value: 'Desert Titanium' },
  { label: 'Natural Titanium', value: 'Natural Titanium' },
];

// Configuration groups and options
const CONFIG_GROUPS = {
  Color: ['Desert Titanium', 'Natural Titanium', 'Black Titanium', 'White Titanium'],
  Storage: ['256GB', '512GB', '1TB'],
  Connectivity: ['Wi‑Fi', 'Wi‑Fi + Cellular'],
};

const portalRoot = document.getElementById('portal-root');
const OptionPortal = ({ children, style }) =>
  createPortal(
    <div className="options-container main-company-body-inner" style={{ ...style, overflow: 'visible', zIndex: 2000, marginTop: '10px' }}>
      {children}
    </div>,
    portalRoot
  );

const productTabs = [
  { key: "white-iphone-16-pro-max", label: "White iPhone 16 Pro Max" },
  { key: "black-iphone-16-pro-max", label: "Black iPhone 16 Pro Max" },
  { key: "pink-iphone-16-pro-max", label: "Pink iPhone 16 Pro Max" },
  { key: "beige-iphone-16-pro-max", label: "Beige iPhone 16 Pro Max" },
  { key: "lilac-iphone-16-pro-max", label: "Lilac iPhone 16 Pro Max" },
  { key: "desert-iphone-16-pro-max", label: "Desert iPhone 16 Pro Max" },
  { key: "purple-iphone-16-pro-max", label: "Purple iPhone 16 Pro Max" },
  { key: "golden-iphone-16-pro-max", label: "Golden iPhone 16 Pro Max" },
  { key: "green-iphone-16-pro-max", label: "Green iPhone 16 Pro Max" },
  { key: "blue-iphone-16-pro-max", label: "Blue iPhone 16 Pro Max" },
];

export default function EditSpu() {
  const history = useHistory();
  const fileInputRef = useRef(null);

  const [uploadedImages, setUploadedImages] = useState([]);
  const [isDragging, setIsDragging] = useState(false);
  const [brands, setBrands] = useState([]);
  const [categories, setCategories] = useState([]);

  const [successMessage, setSuccessMessage] = useState('');
  const [validationError, setValidationError] = useState([]);
  const [disabled, setDisabled] = useState(false);

  const { id } = useParams();
  const [skuAttributes, setSkuAttributes] = useState([]);
  const [skuAttributeOptions, setSkuAttributeOptions] = useState([]);
  const [discardModalOpen, setDiscardModalOpen] = useState(false);
  const [isDirty, setIsDirty] = useState(false);
  // Cleanup all object URLs on unmount
  // run once on mount, cleanup on unmount
  useEffect(() => {
    return () => {
      uploadedImages.forEach(img => URL.revokeObjectURL(img.preview));
    };
  }, []);  // ← NO dependencies


  const handleBrowseClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const [formData, setFormData] = useState({

    model_name: '',
    model_prefix: '',
    model_id: '',
    status: '0',
    os_type: '',
    brand: '',
    category: '',
    release_date: '',
    images: [],
    customised: [],
    notes: '',
  });

  const [errors, setFormErrors] = useState({
    model_name: '',
    model_prefix: '',
    brand: '',
    category: ''
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  useEffect(() => {
  async function fetchSpuData() {
    const response = await apiHelper(`inventory/spus/show/${id}/`, 'GET');
    if (response && response.ok) {
      let result = await response.json();
      result.status = !result.status ? 0 : 1;
      setFormData(result);
      console.log("result", parseInt(result.status));
    }
  }

  async function fetchBrandsData() {
    const response = await apiHelper('inventory/brands/');
    if (response && response.ok) {
      const result = await response.json();
      setBrands(result);
    }
  }

  async function fetchCategoriesData() {
    const response = await apiHelper('inventory/categories/');
    if (response && response.ok) {
      const result = await response.json();
      setCategories(result);
    }
  }

  async function fetchSkuAttributes() {
    const response = await apiHelper('settings/sku-attributes/', 'GET');
    if (response && response.ok) {
      const result = await response.json();
      console.log("attribute", result);
      setSkuAttributes(result.map(attr => ({
        attribute_id: attr.attribute_id,
        attribute_name: attr.attribute_name,
      })));
    }
  }

  async function fetchSkuAttributeOptions() {
    const response = await apiHelper('settings/sku-attributes/options/', 'GET');
    if (response && response.ok) {
      const result = await response.json();
      setSkuAttributeOptions(result.map(opt => ({
        option_id: opt.option_id,
        option_value: opt.option_value, // Changed from option_name to option_value
        attribute: opt.attribute,
      })));
    }
  }

  fetchSkuAttributes();
  fetchSkuAttributeOptions();
  fetchBrandsData();
  fetchCategoriesData();
  fetchSpuData();
}, [id]);

useEffect(() => {
    async function fetchSkuVariations() {
      if (skuAttributes.length === 0 || skuAttributeOptions.length === 0) return; // Wait for dependencies
      const response = await apiHelper(`inventory/sku/spu/${id}/`, 'GET');
      if (response && response.ok) {
        const result = await response.json();
        console.log('fetchSkuVariations: SKU data', result);

        // Extract unique attributes and their non-empty values
        const attributesMap = {};
        result.forEach(sku => {
          Object.keys(sku).forEach(attr => {
            if (sku[attr] && typeof sku[attr] === 'string' && sku[attr].trim() && !['sku_id', 'spu_id', 'created_by', 'modified_by'].includes(attr)) {
              if (!attributesMap[attr]) {
                attributesMap[attr] = new Set();
              }
              attributesMap[attr].add(sku[attr].trim());
            }
          });
        });

        // Map attributes to rows2 format
        const newRows = Object.keys(attributesMap).map((attrName, idx) => {
          // Find matching attribute_id from skuAttributes
          const matchingAttr = skuAttributes.find(
            attr => attr.attribute_name.toLowerCase() === attrName.toLowerCase()
          );
          const fieldName = matchingAttr ? matchingAttr.attribute_id.toString() : '';

          // Map attribute values to opts
          const opts = Array.from(attributesMap[attrName]).map(value => {
            const matchingOption = skuAttributeOptions.find(
              opt => opt.option_value === value && opt.attribute.toString() === fieldName
            );
            return matchingOption
              ? {
                  label: matchingOption.option_value,
                  value: matchingOption.option_id.toString(),
                }
              : null;
          }).filter(opt => opt); // Remove null entries

          return {
            id: idx + 1,
            fieldName,
            opts,
            isOpen: false,
            search: '',
          };
        });

        // Only filter out rows with no fieldName (invalid attributes)
        const validRows = newRows.filter(row => row.fieldName);
        console.log('fetchSkuVariations: newRows', newRows, 'validRows', validRows, 'skuAttributes', skuAttributes, 'skuAttributeOptions', skuAttributeOptions);
        setRows2(validRows);
      } else {
        console.error('fetchSkuVariations failed:', response);
        setRows2([]);
      }
    }

    fetchSkuVariations();
  }, [id, skuAttributes, skuAttributeOptions]);


  const makeImageObjects = (files) => {
    return files
      .slice(0, MAX_IMAGES - uploadedImages.length)
      .map(file => ({
        id: Date.now() + Math.random(),
        file,
        preview: URL.createObjectURL(file),
      }));
  };

  const handleImageChange = (e) => {
    console.log("Input files:", e.target.files);
    const files = Array.from(e.target.files || []);
    const newImgs = makeImageObjects(files);
    console.log("Will add:", newImgs);
    setUploadedImages(prev => [...prev, ...newImgs]);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    const files = Array.from(e.dataTransfer.files || []);
    const newImgs = makeImageObjects(files);
    setUploadedImages(prev => [...prev, ...newImgs]);
  };

  const handleRemove = (id) => {
    setUploadedImages(prev => {
      const img = prev.find(x => x.id === id);
      if (img) URL.revokeObjectURL(img.preview);
      return prev.filter(x => x.id !== id);
    });
  };

  const formatSize = size => {
    const mb = size / (1024 * 1024);
    return `${mb.toFixed(1)}mb`;
  };
const [showItemAlert, setShowItemAlert] = useState(false);
  const handleSave = async () => {

    //console.log("Saving with:", uploadedImages);
    let postFormData = new FormData();
    if (uploadedImages.length) {
      let images = [];
      for (let i of uploadedImages) {
        images.push(i.file);
        postFormData.append('images', i.file);
      }
    }

    if (rows.length) {
      for (let row of rows) {
        if (row.value) {
          let obj = { field_name: row.fieldName, type: row.fieldType, value: row.value };
          postFormData.append('customised', JSON.stringify(obj));
        }
      }
    }


    setDisabled(true);
    let form_errors = { model_name: '', model_prefix: '', brand: '', category: '' };
    let is_error = false;
    if (!formData.model_name) {
      form_errors["model_name"] = "This field is required!";
      is_error = true;
    }
    if (!formData.model_prefix) {
      form_errors["model_prefix"] = "This field is required!";
      is_error = true;
    }
    if (!formData.brand) {
      form_errors["brand"] = "This field is required!";
      is_error = true;
    }
    if (!formData.category) {
      form_errors["category"] = "This field is required!";
      is_error = true;
    }
    setFormErrors(form_errors);
    if (is_error) {
      setDisabled(false);
      return false;
    }


    Object.keys(formData).forEach(key => {
      if (!['images'].includes(key)) {
        postFormData.append(key, formData[key]);
      }
    });

    const response = await apiHelper(`inventory/spus/update/${id}/`, 'POST', postFormData, 'multipart/form-data');
    setDisabled(false);

    if (response) {
      if (response.ok) {
        setSuccessMessage('Spu updated successfully.');
        setValidationError([]);
        setUploadedImages([]);
      }
      else if (response.status == 400) { //for validation error
        const response_errors = await response.json();
        let errors = [];
        for (let i in response_errors) {
          errors.push(`${i}: ${response_errors[i][0]}`);
        }
        setValidationError(errors);
        setSuccessMessage('');
      }
    }

  };
  const handleSaveVariations = async () => {
    setDisabled(true);
    let postFormData = new FormData();
    const variations = rows2.map(row => ({
      attribute_id: parseInt(row.fieldName),
      option_ids: row.opts.map(opt => parseInt(opt.value))
    }));
    console.log('handleSaveVariations: Sending variations', variations, 'to URL', `inventory/update/sku/${id}/`);
    postFormData.append('variations', JSON.stringify(variations));

    try {
      const response = await apiHelper(`inventory/sku/update/${id}/`, 'PUT', postFormData, 'multipart/form-data');
      console.log('handleSaveVariations: Response', response);

      if (response && response.ok) {
        setSuccessMessage('SKU variations updated successfully.');
        setValidationError([]);
        history.push('/spu-sku');
      } else if (response && response.status === 400) {
        const response_errors = await response.json();
        console.log('handleSaveVariations: 400 errors', response_errors);
        let errors = [];
        for (let i in response_errors) {
          console.log("eorrr",`${i}: ${response_errors[i]}`)
          errors.push(`${i}: ${response_errors[i]}`);
        }
        setValidationError(errors);
        setSuccessMessage('');
      } else if (response && response.status === 404) {
        const response_errors = await response.json();
        console.log('handleSaveVariations: 404 error', response_errors);
        setValidationError([response_errors.detail || 'Not found']);
        setSuccessMessage('');
      } else {
        console.log('handleSaveVariations: Other error', response.status);
        setValidationError(['Failed to update SKU variations']);
        setSuccessMessage('');
      }
    } catch (error) {
      console.error('handleSaveVariations: Exception', error);
      setValidationError(['An error occurred while saving SKU variations']);
      setSuccessMessage('');
    } finally {
      setDisabled(false);
    }
  };
   const handleDiscard = () => {
        setDiscardModalOpen(true);
    };
    const handleDiscardConfirm = (confirm) => {
        if (confirm) {
            history.goBack();
        }
        setDiscardModalOpen(false);
    };
    const handleCancelDiscard = () => {
        setDiscardModalOpen(false);
    };

  const [allCompatibility, setAllCompatibility] = useState([
    { role_name: 'iPhone 16 Pro', id: '1' },
    { role_name: 'iPhone 16e', id: '2' },
    { role_name: 'iPhone 16 Pro Max', id: '3' },
    { role_name: 'iPhone 16', id: '4' },
  ]);


  const [selectedCompatibility, setSelectedCompatibility] = useState([]);
  const [isCompatibilityOpen, setIsCompatibilityOpen] = useState(false);
  const [compatibilitySearch, setCompatibilitySearch] = useState('');

  const compatibilityRef = useRef(null);
  useEffect(() => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      compatibility: selectedCompatibility.map((item) => item.id)
    }));
  }, [selectedCompatibility]);

  const toggleCompatibility = () => {
    setIsCompatibilityOpen((prev) => !prev);
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        isCompatibilityOpen &&
        compatibilityRef.current &&
        !compatibilityRef.current.contains(e.target)
      ) {
        setIsCompatibilityOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isCompatibilityOpen]);

  const filteredCompatibility = allCompatibility.filter((g) =>
    g.role_name.toLowerCase().includes(compatibilitySearch.trim().toLowerCase())
  );

  const handleCompatibilityCheckbox = (group) => {
    const exists = selectedCompatibility.findIndex((item) => item.id === group.id);
    if (exists > -1) {
      setSelectedCompatibility((prev) => prev.filter((item) => item.id !== group.id));
    } else {
      setSelectedCompatibility((prev) => [...prev, group]);
    }
  };

  const removeCompatibility = (valueToRemove) => {
    setSelectedCompatibility((prev) =>
      prev.filter((item) => item.id !== valueToRemove)
    );
  };

  const [activeTab2, setActiveTab2] = useState('edit-spu');
  const breadcrumbs = ["Product", "SPU & SKU", "Edit SPU"];

  const [rows, setRows] = useState([
    {
      id: 1, fieldName: 'OS Type',
      fieldType: 'Text',      // or 'Reference'
      refChild: '',           // one of REFERENCE_CHILDREN
      value: 'iOS',              // for Text
      opts: [],               // for multi‑select
      typeOpen: false,        // dropdown open?
      refMenuOpen: false,     // submenu open?
      isOpen: false,          // multi‑select open?
      search: ''              // multi‑select search
    },
    {
      id: 2, fieldName: 'Compatible Devices',
      fieldType: 'Text',
      refChild: '',
      value: '',
      opts: [],
      typeOpen: false,
      refMenuOpen: false,
      isOpen: false,
      search: ''
    }
  ]);
  const rowRefs = useRef({});

  const addRow = () => {
    const newId = rows.length ? Math.max(...rows.map(r => r.id)) + 1 : 1;
    setRows([...rows, { id: newId, fieldName: '', fieldType: 'Text', refChild: '', value: '', opts: [], typeOpen: false, refMenuOpen: false, isOpen: false, search: '' }]);
  };
  const deleteRow = id => setRows(rows.filter(r => r.id !== id));
  const updateRowBulk = (id, changes) => setRows(rows.map(r => r.id === id ? { ...r, ...changes } : r));

  // Close dropdowns on outside click
  useEffect(() => {
    const handler = e => {
      const inPortal = portalRoot?.contains(e.target);
      setRows(rs => rs.map(r => {
        const el = rowRefs.current[r.id]?.current;
        if (!inPortal && el && !el.contains(e.target)) {
          return { ...r, typeOpen: false, refMenuOpen: false, isOpen: false };
        }
        return r;
      }));
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const [showMissingSku, setShowMissingSku] = useState(true);

  // inside your component, after your useState:
  useEffect(() => {
    if (rows.length === 0) {
      setShowMissingSku(true);
    }
  }, [rows.length]);

  const archivedRef = useRef(null);
  const [archivedModalOpen, setArchivedModalOpen] = useState(false);
  const [selectedEmployeeId, setSelectedEmployeeId] = useState(null); // optional

  const handleArchivedConfirm = () => {
    console.log("Archiving:", selectedEmployeeId); // or your logic
    setArchivedModalOpen(false);
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (archivedRef.current && !archivedRef.current.contains(event.target)) {
        setArchivedModalOpen(false);
      }
    }

    if (archivedModalOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [archivedModalOpen]);


  //Tab 2
  // const [rows2, setRows2] = useState([
  //   { id: 1, fieldName: 'Color', opts: [], isOpen: false, search: '' },
  //   { id: 2, fieldName: 'Storage', opts: [], isOpen: false, search: '' },
  // ]);
  const [rows2, setRows2] = useState([]);
  const rowRefs2 = useRef({});
  const [showMissingVar, setShowMissingVar] = useState(true);

  // show alert if no rows
  useEffect(() => {
    if (rows2.length === 0) setShowMissingVar(true);
  }, [rows2.length]);

  function addRow2() {
    const newId = rows2.length ? Math.max(...rows2.map(r => r.id)) + 1 : 1;
    // Select the first available attribute not used in other rows
    const usedAttributes = rows2.map(r => r.fieldName).filter(Boolean);
    const availableAttribute = skuAttributes.find(
      attr => !usedAttributes.includes(attr.attribute_id.toString())
    );
    const newRow = {
      id: newId,
      fieldName: availableAttribute ? availableAttribute.attribute_id.toString() : '',
      opts: [],
      isOpen: false,
      search: '',
    };
    console.log('addRow2: newRow', newRow, 'availableAttribute', availableAttribute);
    setRows2([...rows2, newRow]);
  }

  const deleteRow2 = id => setRows2(rows2.filter(r => r.id !== id));
  const updateRow2 = (id, changes) =>
    setRows2(rows2.map(r => (r.id === id ? { ...r, ...changes } : r)));

  // close dropdowns on outside click
  useEffect(() => {
    const handler = e => {
      const inPortal = portalRoot?.contains(e.target);
      setRows2(rs =>
        rs.map(r => {
          const el = rowRefs2.current[r.id]?.current;
          if (!inPortal && el && !el.contains(e.target)) {
            return { ...r, isOpen: false };
          }
          return r;
        })
      );
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  //Tab 3
  const [rows3, setRows3] = useState([
    { id: 1, fieldName: 'White iPhone 16 Pro Max', opts: [], isOpen: false },
    { id: 2, fieldName: 'Black iPhone 16 Pro Max', opts: [], isOpen: false },
  ]);
  const rowRefs3 = useRef({});

  const addRow3 = () => {
    const newId = rows3.length ? Math.max(...rows3.map(r => r.id)) + 1 : 1;
    setRows3([...rows3, { id: newId, fieldName: '', opts: [], isOpen: false }]);
  };

  const deleteRow3 = id => setRows3(rows3.filter(r => r.id !== id));
  const updateRow3 = (id, changes) =>
    setRows3(rows3.map(r => (r.id === id ? { ...r, ...changes } : r)));

  // Close dropdown on outside click
  useEffect(() => {
    const handler = e => {
      const inPortal = portalRoot?.contains(e.target);
      setRows3(rs =>
        rs.map(r => {
          const el = rowRefs3.current[r.id]?.current;
          if (!inPortal && el && !el.contains(e.target)) {
            return { ...r, isOpen: false };
          }
          return r;
        })
      );
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const currentRowsEmpty =
    activeTab2 === 'sku-variations'
      ? rows2.length === 0
      : activeTab2 === 'sku-configurations'
        ? rows3.length === 0
        : rows.length === 0;

  const [showMissingCfg, setShowMissingCfg] = useState(true);

  // reset the alert whenever rows3 goes to zero
  useEffect(() => {
    if (rows3.length === 0) {
      setShowMissingCfg(true);
    }
  }, [rows3.length]);

  //Tab 3 same data of input field alert box code

  // new state for the “exists” alert
  const [showCfgExists, setShowCfgExists] = useState(false);

  // whenever rows3 changes, check for duplicate fieldName
  useEffect(() => {
    const names = rows3.map(r => r.fieldName.trim()).filter(n => n);
    const hasDup = names.some((n, i) => names.indexOf(n) !== i);
    setShowCfgExists(hasDup);
  }, [rows3]);

  const [productTab, setProductTab] = useState('white-iphone-16-pro-max');

  //Tab 3 product info tabs code below
  const [activeTab, setActiveTab] = useState(productTabs[0].key);
  const [overflowTabs, setOverflowTabs] = useState([]);
  const [menuOpen, setMenuOpen] = useState(false);
  const [menuStyles, setMenuStyles] = useState({ top: 0, left: 0, direction: "down" });
  const containerRef = useRef(null);
  const triggerRef = useRef(null);
  const tabRefs = useRef({});

  function calcOverflow() {
    if (!containerRef.current) return;
    const contW = containerRef.current.clientWidth;
    const trigW = triggerRef.current?.offsetWidth || 40;
    let used = 0;
    const vis = [];
    const over = [];

    productTabs.forEach(tab => {
      const btn = tabRefs.current[tab.key];
      if (!btn) return;
      const w = btn.offsetWidth;
      if (tab.key === activeTab || used + w < contW - trigW) {
        vis.push(tab.key);
        used += w;
      } else {
        over.push(tab.key);
      }
    });

    setOverflowTabs(over);
  }

  // measure before paint so icon is in right place
  useLayoutEffect(() => {
    // Delay 1 frame to ensure refs are ready
    requestAnimationFrame(() => {
      calcOverflow();
      scrollActiveTabIntoView();
    });
  }, [activeTab]);

  function scrollActiveTabIntoView() {
    const activeEl = tabRefs.current[activeTab];
    if (activeEl && containerRef.current) {
      activeEl.scrollIntoView({
        behavior: "smooth",
        inline: "center",
        block: "nearest"
      });
    }
  }


  // recalc on resize
  useEffect(() => {
    window.addEventListener("resize", calcOverflow);
    return () => window.removeEventListener("resize", calcOverflow);
  }, []);

  function toggleMenu() {
    if (!triggerRef.current) return;
    const rect = triggerRef.current.getBoundingClientRect();
    const spaceBelow = window.innerHeight - rect.bottom;
    const direction = spaceBelow < 200 ? "up" : "down";
    setMenuStyles({
      top: direction === "down" ? rect.bottom + window.scrollY : rect.top + window.scrollY,
      left: rect.right + window.scrollX - 200, // 200 = approx menu width
      direction
    });
    setMenuOpen(open => !open);
  }

  // render the portal menu
  const portalMenu = menuOpen && createPortal(
    <ul
      className={`pt-portal-menu ${menuStyles.direction}`}
      style={{
        position: "absolute",
        top: `${menuStyles.top}px`,
        left: `${menuStyles.left}px`
      }}
    >
      {productTabs.map(tab => (
        <li key={tab.key}>
          <button
            className={`pt-portal-item ${activeTab === tab.key ? "selected" : ""}`}
            onClick={() => {
              setActiveTab(tab.key);
              setMenuOpen(false);
            }}
          >
            {tab.label}
          </button>
        </li>
      ))}
    </ul>,
    document.body
  );

   const handleChangeWithDirty = (e) => {
        setIsDirty(true);
        handleChange(e);
    };

  return (
    <>
      <div className="company-body main-company-body-inner new-look">
        <div className="breadcrumb">
          {breadcrumbs.map((crumb, index) => {
            const isLast = index === breadcrumbs.length - 1;
            return (
              <span
                key={index}
                className={`breadcrumb-item ${crumb === "SPU & SKU" ? "clickable" : ""}`}
                onClick={() => {
                  if (crumb === "SPU & SKU") {
                    history.push("/spu-sku");
                  }
                }}
                style={{ cursor: crumb === "SPU & SKU" ? "pointer" : "default" }}
              >
                {crumb}
                {!isLast ? "  " : ""}
              </span>
            );
          })}
        </div>

        <div className='edit-organisation-info'>
          <div className='edit-organisation-left'>
            <h1>Edit SPU</h1>
          </div>
          <div className='discard-save-organisation-right d-flex align-items-center justify-content-end flex-wrap gap-2'>
            <button
              className="dark-button"
              type='button'
              onClick={handleDiscard}
            >
              Cancel
            </button>
             <DiscardConfirmationModal
                            isOpen={discardModalOpen}
                            onCancel={handleCancelDiscard}
                            onConfirm={handleDiscardConfirm}
                            entityName="Spu"  // 🔁 Change dynamically (e.g., “Category”, “Stock”)
                        />

            <button
              className={`dark-button ${currentRowsEmpty ? 'disabled' : ''}`}
              type="button"
              onClick={ () => {
                                if(activeTab2 === 'edit-spu'){
                                    handleSave()    
                                }
                                if(activeTab2 === 'sku-variations'){
                                     handleSaveVariations()
                                }
                                
                            }}
              disabled={currentRowsEmpty}
              style={currentRowsEmpty ? {
                backgroundColor: '#CED4DA',
                color: '#fff',
                borderColor: 'transparent'
              } : {}}
            >
              {activeTab2 === 'sku-variations'
                ? 'Save and Return to SPU'
                : activeTab2 === 'sku-configurations'
                  ? 'Save and Return to SKU'
                  : activeTab2 === 'sku-code'
                    ? 'Save and Return to SKU'
                    : 'Save & Exit'}
            </button>

            <button
              className={`dark-border ${currentRowsEmpty ? 'disabled' : ''}`}
              type="button"
              onClick={() => {
                // show alert immediately on button click
                setShowItemAlert(true);
                setTimeout(() => setShowItemAlert(false), 3000);
                if (activeTab2 === 'sku-variations') {
                  setArchivedModalOpen(true);
                } else {
                  handleSave();
                }
              }}
              disabled={currentRowsEmpty}
              style={currentRowsEmpty ? {
                backgroundColor: '#CED4DA',
                color: '#fff',
                borderColor: 'transparent'
              } : {}}
            >
              {activeTab2 === 'sku-variations'
                ? 'Save and Configure SKU'
                : activeTab2 === 'sku-configurations'
                  ? 'Save & Exit'
                  : activeTab2 === 'sku-code'
                    ? 'Save & Exit'
                    : 'Save and add to SKUs'}
            </button>
          </div>
        </div>
        {showItemAlert && (
          <div
              className="d-flex align-items-center justify-content-between"
              role="alert"
              style={{
                  boxShadow: "0px 4px 10px 0px #0000001F",
                  padding: "15px 10px",
                  borderRadius: "12px",
                  border: "1px solid #30B473",
                  backgroundColor: "#E6F7EF",
                  color: "#0D6438",
                  fontSize: "12px",
                  position: "fixed",
                  top: "10px",
                  width: "calc(100% - 20px)",
                  maxWidth: "640px",
                  left: "50%",
                  transform: "translateX(-50%)",
                  zIndex: 2000,
              }}
          >
              <div className="d-flex align-items-center">
                  <CircleCheck className="me-2" />
                  <div
                      style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "4px",
                      }}
                  >
                      <strong>SPU edited successfully</strong>
                  </div>
              </div>

              <X
                  size={16}
                  style={{ cursor: "pointer" }}
                  onClick={() => setShowItemAlert(false)}
              />
          </div>
      )}
        <div className="employee-tabs-container">
          {/* ─── Tab Buttons ─── */}
          <div className="tabs">
            <button
              className={`tab ${activeTab2 === 'edit-spu' ? 'active' : ''}`}
              onClick={() => setActiveTab2('edit-spu')}
            >
              Edit SPU
            </button>
            <button
              className={`tab ${activeTab2 === 'sku-variations' ? 'active' : ''}`}
              onClick={() => setActiveTab2('sku-variations')}
            >
              SKU Variations
            </button>
            <button
              className={`tab ${activeTab2 === 'sku-configurations' ? 'active' : ''}`}
              onClick={() => setActiveTab2('sku-configurations')}
            >
              SKU Configurations
            </button>
            <button
              className={`tab ${activeTab2 === 'sku-code' ? 'active' : ''}`}
              onClick={() => setActiveTab2('sku-code')}
            >
              SKU Code
            </button>
          </div>

          {successMessage && <div style={{ color: 'green' }} className="success-message">{successMessage}</div>}
          <ul style={{ color: 'red' }}>
            {validationError && validationError.map((error, index) => (
              <li key={index}>{error}</li>
            ))}
          </ul>

          {activeTab2 === 'edit-spu' && (
            <div className="tab-content" id="edit-spu-content">
              <div className="info-section">
                {/* ─── SPU INFO CARD ─────────────────────────────────────────── */}
                <div className="info-card new-info-overflow-auto">
                  <div className="info-header">
                    <h4 className="info-title">Basic Info</h4>
                  </div>
                  <div className="info-content d-block">
                    <div className='grid-info-adding'>

                      {/* ─── ROW 1: SPU NAME & STATUS ───────────────────────────────── */}
                      <div className='row gappingcls-added'>
                        <div className='col-lg-6 col-md-6 col-12'>
                          <div className="info-inner">
                            <label
                              htmlFor="spuName"
                              className="form-label d-flex align-items-center gap-1"
                            >
                              SPU Name <span className='error-color'>*</span>
                              <Tooltip content="SPU Name">
                                <Info size={16} className="info-icon" />
                              </Tooltip>
                            </label>

                            <input
                              type="text"
                              className="form-control common-input-all"
                              id="spuName"
                              placeholder="SPU Name"
                              name="model_name"
                              value={formData.model_name}
                              onChange={handleChangeWithDirty}
                            />
                            {errors.model_name && <p style={{ color: 'red' }}>{errors.model_name}</p>}
                          </div>
                        </div>
                        <div className='col-lg-6 col-md-6 col-12'>
                          <div className="info-inner">
                            <label htmlFor="status" className="form-label">
                              Status <span className='error-color'>*</span>
                            </label>
                            <div className='flexing-type-radio'>
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  id="flexRadioDefault1"
                                  name="status"
                                  value="1"
                                  checked={formData.status === 1}
                                  onChange={handleChangeWithDirty}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="flexRadioDefault1"
                                  style={{ fontWeight: 'normal', fontSize: '14px' }}
                                >
                                  Active
                                </label>
                              </div>
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="status"
                                  value="0"
                                  checked={formData.status === 0}
                                  onChange={handleChangeWithDirty}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="flexRadioDefault2"
                                  style={{ fontWeight: 'normal', fontSize: '14px' }}
                                >
                                  Inactive
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* ─── ROW 2: ID & Model Prefix  ─────────────────────────────────────── */}
                      <div className='row gappingcls-added'>
                        <div className='col-lg-6 col-md-6 col-12'>
                          <div className="info-inner">
                            <label
                              htmlFor="spuId"
                              className="form-label d-flex align-items-center gap-2"
                            >
                              ID
                              <Tooltip content="A shorter, human-friendly label for your spu">
                                <Info size={16} className="info-icon" />
                              </Tooltip>
                            </label>
                            <input
                              type="text"
                              className="form-control common-input-all"
                              id="spuId"
                              placeholder="SPU ID"
                              name="model_id"
                              value={formData.model_id} onChange={handleChangeWithDirty}
                            />
                          </div>
                        </div>
                        <div className='col-lg-6 col-md-6 col-12'>
                          <div className="info-inner">
                            <label
                              htmlFor="modelPrefix"
                              className="form-label d-flex align-items-center gap-1"
                            >
                              Model Prefix
                              <Tooltip content="A shorter, human-friendly label for your spu">
                                <Info size={16} className="info-icon" />
                              </Tooltip>
                            </label>
                            <input
                              type="text"
                              className="form-control common-input-all"
                              id="modelPrefix"
                              placeholder="Model Prefix"
                              name="model_prefix"
                              value={formData.model_prefix} onChange={handleChangeWithDirty}
                            />
                          </div>
                        </div>
                      </div>

                    </div> {/* end of grid-info-adding */}
                  </div> {/* end of info-content */}
                </div> {/* end of info-card */}

                {/* ─── Product INFO CARD ─────────────────────────────────────────── */}
                <div className="info-card new-info-overflow-auto">
                  <div className="info-header">
                    <h4 className="info-title">Product Info</h4>
                  </div>
                  <div className="info-content d-block">
                    <div className='grid-info-adding'>
                      {/* ─── ROW 1: Brand & Category  ────────────── */}
                      <div className='row gappingcls-added'>

                        <div className='col-lg-6 col-md-6 col-12'>
                          <div className="info-inner">
                            <label
                              htmlFor="brand"
                              className="form-label d-flex align-items-center gap-1"
                            >
                              Brand <span className='error-color'>*</span>
                              <Tooltip content="Human-friendly label for your spu">
                                <Info size={16} className="info-icon" />
                              </Tooltip>
                            </label>
                            <select
                              className="form-select new-form-select-cls"
                              aria-label="Default select example"
                              name="brand"
                              value={formData.brand}
                              onChange={handleChangeWithDirty}
                            >
                              {brands && brands.map((item, index) => (
                                <option key={index} value={item.brand_id}>{item.brand_name}</option>
                              ))}
                              {errors.brand && <p style={{ color: 'red' }}>{errors.brand}</p>}
                            </select>
                          </div>
                        </div>
                        <div className='col-lg-6 col-md-6 col-12'>
                          <div className="info-inner">
                            <label
                              htmlFor="category"
                              className="form-label d-flex align-items-center gap-1"
                            >
                              Category <span className='error-color'>*</span>
                              <Tooltip content="Human-friendly label for your spu">
                                <Info size={16} className="info-icon" />
                              </Tooltip>
                            </label>
                            <select
                              className="form-select new-form-select-cls"
                              aria-label="Default select example"
                              name="category"
                              value={formData.category}
                              onChange={handleChangeWithDirty}
                            >
                              {categories && categories.map((item, index) => (
                                <option key={index} value={item.category_id}>{item.category_name}</option>
                              ))}
                            </select>
                            {errors.category && <p style={{ color: 'red' }}>{errors.category}</p>}
                          </div>
                        </div>

                      </div>
                      {/* ─── ROW 2: Type & Release Date  ────────────── */}
                      <div className='row gappingcls-added'>

                        <div className='col-lg-6 col-md-6 col-12'>
                          <div className="info-inner">
                            <label
                              htmlFor="type"
                              className="form-label d-flex align-items-center gap-1"
                            >
                              Type
                              <Tooltip content="A shorter, human-friendly label for your spu">
                                <Info size={16} className="info-icon" />
                              </Tooltip>
                            </label>
                            <select
                              className="form-select new-form-select-cls"
                              aria-label="Default select example"
                              name="os_type"
                              value={formData.os_type}
                              onChange={handleChangeWithDirty}
                            >
                              <option>Device</option>
                              <option>Smartphone</option>
                              <option>Tablet</option>
                            </select>
                          </div>
                        </div>
                        <div className='col-lg-6 col-md-6 col-12'>
                          <div className="info-inner">
                            <label
                              htmlFor="release_date"
                              className="form-label d-flex align-items-center gap-1"
                            >
                              Release Date
                              <Tooltip content="Human-friendly label for your entity">
                                <Info size={16} className="info-icon" />
                              </Tooltip>
                            </label>
                            <input
                              type="date"
                              className="form-control common-input-all"
                              id="release_date"
                              placeholder="Release Date"
                              name="release_date"
                              pattern="\d{4}-\d{2}-\d{2}"
                              value={formData.release_date}
                              onChange={handleChangeWithDirty}
                            />
                          </div>
                        </div>

                      </div>
                      {/* ─── ROW 3: Images  ────────────── */}
                      <div className="row gappingcls-added">
                        <div className="col-12">
                          <div className="info-inner">
                            <label className="form-label d-flex align-items-center gap-2">
                              Images
                              <Tooltip content="Upload your spu images">
                                <Info size={16} className="info-icon" />
                              </Tooltip>
                            </label>

                            {/* Dropzone */}
                            <div
                              className="upload-container"
                              onClick={handleBrowseClick}
                              onDragOver={e => e.preventDefault()}
                              onDragEnter={() => setIsDragging(true)}
                              onDragLeave={() => setIsDragging(false)}
                              onDrop={handleDrop}
                              style={{
                                border: '2px dashed #ccc',
                                borderRadius: 4,
                                padding: '3rem 1.5rem',
                                textAlign: 'center',
                                cursor: 'pointer',
                                backgroundColor: isDragging ? '#CFE2FF' : '#fff', // Drag highlight
                                borderColor: isDragging ? '#0D6EFD' : '#ccc', // Drag highlight
                                transition: 'background-color 0.3s ease',
                              }}
                            >
                              <CloudUpload size={32} />
                              <p style={{ margin: 0, color: '#555', fontSize: '0.9rem' }}>
                                Drag your image here or{' '}
                                <span style={{ color: '#007bff', textDecoration: 'underline' }}>
                                  Browse
                                </span>
                              </p>
                              <input
                                type="file"
                                accept="image/*"
                                multiple
                                ref={fileInputRef}
                                style={{ display: 'none' }}
                                onChange={handleImageChange}
                              />
                            </div>

                            {/* Uploaded Images */}
                            {uploadedImages.length > 0 && (
                              <div className="uploaded-images mt-3">
                                <p className='mb-3'>
                                  {uploadedImages.length} Image
                                  {uploadedImages.length > 1 ? 's' : ''} uploaded
                                </p>

                                <ReactSortable
                                  list={uploadedImages}
                                  setList={setUploadedImages}
                                  handle=".drag-handle"
                                  tag="div"
                                  className="row g-2"
                                  chosenClass="is-dragging"    // ← this class goes on the dragged item
                                >
                                  {uploadedImages.map(img => (
                                    <div className="col-md-4 col-sm-6" key={img.id}>
                                      <div className="d-flex align-items-center justify-content-between p-2 border rounded" style={{ boxShadow: '0px 1px 4px 0px #0000001A' }}>
                                        <div className="d-flex align-items-center gap-2">
                                          <X size={18} onClick={() => handleRemove(img.id)} className="cursor-pointer" style={{ flex: 'none' }} />
                                          <img
                                            src={img.preview}
                                            alt="preview"
                                            style={{
                                              width: 40,
                                              height: 40,
                                              objectFit: 'cover',
                                              borderRadius: 4,
                                            }}
                                          />
                                          <div>
                                            <div style={{ fontSize: '0.85rem', fontWeight: 500, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '150px', color: '#6C757D' }}>
                                              {img.file.name}
                                            </div>
                                            <div style={{ fontSize: '0.75rem', color: '#6C757D' }}>{formatSize(img.file.size)}</div>
                                          </div>
                                        </div>
                                        <Menu
                                          size={16}
                                          className="drag-handle text-muted"
                                          style={{ cursor: 'grab', flex: 'none' }}
                                        />
                                      </div>
                                    </div>
                                  ))}
                                </ReactSortable>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                     <UnsavedChangesPrompt isDirty={isDirty} />
                  </div>
                </div>

                {/* ─── Customised Info CARD ─────────────────────────────────────────── */}
                <div className="info-card new-info-overflow-auto main-company-body-inner">
                  <div className="info-header"><h4 className="info-title">Customised Info</h4></div>
                  <div className="info-content d-block entities-tab">
                    <div style={{ padding: '20px', boxShadow: '0px 1px 4px #0000001A', borderRadius: '12px' }}>
                      {rows.length === 0 && showMissingSku && (
                        <div
                          className="d-flex align-items-center justify-content-between"
                          role="alert"
                          style={{
                            boxShadow: '0px 4px 10px 0px #0000001F',
                            padding: '15px 10px',
                            borderRadius: '12px',
                            border: '1px solid #DC3545',
                            backgroundColor: '#F8D7DA',
                            color: '#58151C',
                            fontSize: '12px',
                            position: 'fixed',
                            top: '10px',
                            width: 'calc(100% - 20px)',
                            maxWidth: '640px',
                            left: '50%',
                            transform: 'translateX(-50%)',
                            zIndex: 2000
                          }}
                        >
                          <div className="d-flex align-items-center">
                            <Info className="me-2" />
                            <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                              <strong>Missing SKU:</strong> Please add a default SKU to save your SPU, or proceed to the next step
                            </div>
                          </div>

                          <X
                            size={16}
                            style={{ cursor: 'pointer' }}
                            onClick={() => setShowMissingSku(false)}
                          />
                        </div>
                      )}


                      <div className="table-wrapper" style={{ position: 'relative', overflowX: 'auto' }}>
                        <table className="entities-table tab-table w-100">
                          <thead>
                            <tr>
                              <th />
                              <th><span>Level <ChevronsUpDown size={12} /></span></th>
                              <th><span>Field Name <ChevronsUpDown size={12} /></span></th>
                              <th><span>Field Type <ChevronsUpDown size={12} /></span></th>
                              <th><span>Field Value <ChevronsUpDown size={12} /></span></th>
                              <th /></tr>
                          </thead>
                          <ReactSortable list={rows} setList={setRows} handle=".drag-handle" tag="tbody">
                            {rows.map((r, idx) => {
                              if (!rowRefs.current[r.id]) rowRefs.current[r.id] = React.createRef();
                              const ref = rowRefs.current[r.id];
                              return <EntityRow key={r.id} refNode={ref} rowState={r} index={idx}
                                deleteRow={deleteRow} updateRowBulk={updateRowBulk} />;
                            })}
                          </ReactSortable>
                        </table>
                      </div>
                      <div className="edit-organisation-info" style={{ display: 'flex', marginTop: '20px', marginBottom: '0', boxShadow: 'none', padding: '0' }}>
                        <button onClick={addRow} className="dark-button">Add Fields</button>
                      </div>
                    </div>
                  </div>
                </div>

                {/* ─── ADDITIONAL INFO CARD ─────────────────────────────────────────── */}
                <div className="info-card">
                  <div className="info-header">
                    <h4 className="info-title">Additional Info</h4>
                  </div>
                  <div className="info-content">
                    <div className="info-inner common-textarea">
                      <label
                        htmlFor="exampleFormControlTextarea1"
                        className="form-label"
                      >
                        Note
                      </label>
                      <textarea
                        className="form-control w-100 common-textarea-all"
                        id="exampleFormControlTextarea1"
                        rows="3"
                        name="notes"
                        value={formData.notes}
                        onChange={handleChangeWithDirty}
                      ></textarea>
                      
                    </div>
                  </div>
                </div>
              </div> {/* end of info-section */}
            </div>
          )}
          {activeTab2 === 'sku-variations' && (
              <div className="tab-content" id="sku-variations-content">
                <div className="info-section">
                  <div className="info-card new-info-overflow-auto main-company-body-inner">
                    <div className="info-header"><h4 className="info-title">SKU Variations</h4></div>
                    <div className="info-content d-block entities-tab">
                      <div style={{ padding: '20px', boxShadow: '0px 1px 4px #0000001A', borderRadius: '12px' }}>
                        {rows2.length === 0 && showMissingVar && (
                          <div
                            className="d-flex align-items-center justify-content-between"
                            role="alert"
                            style={{
                              boxShadow: '0px 4px 10px 0px #0000001F',
                              padding: '15px 10px',
                              borderRadius: '12px',
                              border: '1px solid #DC3545',
                              backgroundColor: '#F8D7DA',
                              color: '#58151C',
                              fontSize: '12px',
                              position: 'fixed',
                              top: '10px',
                              width: 'calc(100% - 20px)',
                              maxWidth: '640px',
                              left: '50%',
                              transform: 'translateX(-50%)',
                              zIndex: 2000
                            }}
                          >
                            <div className="d-flex align-items-center">
                              <Info className="me-2" />
                              <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                <strong>Missing SKU</strong> —— Please add a default SKU to save your SPU, or proceed to the next step
                              </div>
                            </div>
                            <X size={16} style={{ cursor: 'pointer' }} onClick={() => setShowMissingVar(false)} />
                          </div>
                        )}
                        <div className="table-wrapper" style={{ position: 'relative', overflowX: 'auto' }}>
                          <table className="entities-table tab-table w-100">
                            <thead>
                              <tr>
                                <th />
                                <th><span>Level <ChevronsUpDown size={12} /></span></th>
                                <th><span>Variation Name <ChevronsUpDown size={12} /></span></th>
                                <th><span>Variations <ChevronsUpDown size={12} /></span></th>
                                <th />
                              </tr>
                            </thead>
                            <ReactSortable list={rows2} setList={setRows2} handle=".drag-handle" tag="tbody">
                              {rows2.map((r, idx) => {
                                if (!rowRefs2.current[r.id]) rowRefs2.current[r.id] = React.createRef();
                                return (
                                  <VariationRow
                                    key={r.id}
                                    refNode={rowRefs2.current[r.id]}
                                    rowState={r}
                                    index={idx}
                                    deleteRow={deleteRow2}
                                    updateRow={updateRow2}
                                    skuAttributes={skuAttributes}
                                    skuAttributeOptions={skuAttributeOptions}
                                    rows2={rows2} // Pass rows2 to track selected attributes and options
                                  />
                                );
                              })}
                            </ReactSortable>
                          </table>
                        </div>
                        <div className="edit-organisation-info" style={{ display: 'flex', marginTop: '20px', marginBottom: '0', boxShadow: 'none', padding: '0' }}>
                          <button onClick={addRow2} className="dark-button">Add SKU</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          {archivedModalOpen && (
            <>
              {/* Overlay */}
              <div className="drawer-overlay" />

              <div
                className="entity-drawer modal-popup-cls"
                ref={archivedRef}
                style={{
                  maxWidth: 650,
                  margin: "0 auto",
                  background: "white",
                  borderRadius: 12,
                  zIndex: 1050,
                  padding: 24,
                  position: "fixed",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.2)",
                  height: "auto",
                  right: "auto",
                  overflow: "inherit",
                }}
              >
                <div className="drawer-header d-flex justify-content-end align-items-center pt-0 pe-0">
                  <button className="close-btn" onClick={() => setArchivedModalOpen(false)}>
                    <X size={20} />
                  </button>
                </div>

                <h3 style={{
                  textAlign: "left", color: "#212529", fontSize: "20px",
                  fontWeight: "600", lineHeight: "24px", fontFamily: "Montserrat",
                  marginBottom: "5px"
                }}>The SPU can’t be archived</h3>

                <p style={{
                  marginBottom: "0", textAlign: "left", color: "#6C757D",
                  fontSize: "14px", fontWeight: "400", lineHeight: "20px",
                  fontFamily: "Montserrat"
                }}>
                  This SPU can’t be archived because it’s referenced by one or more SPUs.
                  Please remove or reassign those SPUs before archiving.
                </p>

                <div className="drawer-footer" style={{ paddingTop: "10px" }}>
                  <button className="btn-save" onClick={handleArchivedConfirm}>
                    OK
                  </button>
                </div>
              </div>
            </>
          )}

          {activeTab2 === 'sku-configurations' && (
            <div className="tab-content" id="sku-configurations-content">
              <div className="info-section">
                {/* ─── SKU Configurations CARD ─────────────────────────────────────────── */}
                <div className="info-card new-info-overflow-auto main-company-body-inner">
                  <div className="info-header"><h4 className="info-title">Configuration List</h4></div>
                  <div className="info-content d-block entities-tab">
                    <div style={{ padding: '20px', boxShadow: '0px 1px 4px #0000001A', borderRadius: '12px' }}>
                      {showCfgExists && (
                        <div
                          className="d-flex align-items-center justify-content-between"
                          role="alert"
                          style={{
                            boxShadow: '0px 4px 10px 0px #0000001F',
                            padding: '15px 10px',
                            borderRadius: '12px',
                            border: '1px solid #DC3545',
                            backgroundColor: '#F8D7DA',
                            color: '#58151C',
                            fontSize: '12px',
                            position: 'fixed',
                            top: '10px',
                            width: 'calc(100% - 20px)',
                            maxWidth: '535px',
                            left: '50%',
                            transform: 'translateX(-50%)',
                            zIndex: 2000
                          }}
                        >
                          <div className="d-flex align-items-center">
                            <Info className="me-2" />
                            <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                              <strong>Configuration Exists:</strong> Please choose different variant combinations
                            </div>
                          </div>
                          <X
                            size={16}
                            style={{ cursor: 'pointer' }}
                            onClick={() => setShowCfgExists(false)}
                          />
                        </div>
                      )}
                      {rows3.length === 0 && showMissingCfg && (
                        <div
                          className="d-flex align-items-center justify-content-between"
                          role="alert"
                          style={{
                            boxShadow: '0px 4px 10px 0px #0000001F',
                            padding: '15px 10px',
                            borderRadius: '12px',
                            border: '1px solid #FFC107',
                            backgroundColor: '#FFF3CD',
                            color: '#664D03',
                            fontSize: '12px',
                            position: 'fixed',
                            top: '10px',
                            width: 'calc(100% - 20px)',
                            maxWidth: '640px',
                            left: '50%',
                            transform: 'translateX(-50%)',
                            zIndex: 2000
                          }}
                        >
                          <div className="d-flex align-items-center">
                            <Info className="me-2" />
                            <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                              <strong>Missing Configuration:</strong> Please add a configuration to proceed
                            </div>
                          </div>
                          <X
                            size={16}
                            style={{ cursor: 'pointer' }}
                            onClick={() => setShowMissingCfg(false)}
                          />
                        </div>
                      )}
                      <div className="table-wrapper" style={{ position: 'relative', overflowX: 'auto' }}>
                        <table className="entities-table tab-table w-100">
                          <thead>
                            <tr>
                              <th />
                              <th><span>Level <ChevronsUpDown size={12} /></span></th>
                              <th><span>Configuration Name <ChevronsUpDown size={12} /></span></th>
                              <th><span>Configuration Options <ChevronsUpDown size={12} /></span></th>
                              <th /></tr>
                          </thead>
                          <ReactSortable list={rows3} setList={setRows3} handle=".drag-handle" tag="tbody">
                            {rows3.map((r, idx) => {
                              if (!rowRefs3.current[r.id]) rowRefs3.current[r.id] = React.createRef();
                              return (
                                <ConfigRow
                                  key={r.id}
                                  refNode={rowRefs3.current[r.id]}
                                  rowState={r}
                                  index={idx}
                                  deleteRow={deleteRow3}
                                  updateRow={updateRow3}
                                />
                              );
                            })}
                          </ReactSortable>
                        </table>
                      </div>
                      <div className="edit-organisation-info" style={{ display: 'flex', marginTop: '20px', marginBottom: '0', boxShadow: 'none', padding: '0' }}>
                        <button onClick={addRow3} className="dark-button">Add Configurations</button>
                      </div>
                    </div>
                  </div>
                </div>
                {/* ─── Product Info CARD ─────────────────────────────────────────── */}
                <div className="info-card new-info-overflow-auto main-company-body-inner">
                  <div className="info-content d-block entities-tab">
                    <div className="pt-container">
                      <div className="tabs-wrapper">
                        <div className="tabs" ref={containerRef}>
                          {productTabs
                            .filter(t => !overflowTabs.includes(t.key))
                            .map(tab => (
                              <button
                                key={tab.key}
                                ref={el => el && (tabRefs.current[tab.key] = el)}
                                className={`tab ${activeTab === tab.key ? "active" : ""}`}
                                onClick={() => {
                                  setActiveTab(tab.key);
                                  setMenuOpen(false);
                                }}
                              >
                                {tab.label}
                              </button>
                            ))}
                        </div>

                        <button
                          ref={triggerRef}
                          className={`tab-trigger ${menuOpen ? "active" : ""}`}
                          onClick={toggleMenu}
                        >
                          <ChevronDown className="h-5 w-5" />
                        </button>
                      </div>

                      {/* portal menu */}
                      {portalMenu}

                      {/* your tab contents */}
                      <div className="tab-content" style={{ marginTop: '20px' }}>
                        {activeTab === "white-iphone-16-pro-max" && <>
                          <div className='grid-info-adding'>
                            {/* ─── ROW 1: STATUS & GTIN ───────────────────────────────── */}
                            <div className='row gappingcls-added'>
                              <div className='col-lg-6 col-md-6 col-12'>
                                <div className="info-inner">
                                  <label htmlFor="status" className="form-label">
                                    Status <span className='error-color'>*</span>
                                  </label>
                                  <div className='flexing-type-radio'>
                                    <div className="form-check">
                                      <input
                                        className="form-check-input"
                                        type="radio"
                                        name="flexRadioDefault"
                                        id="flexRadioDefault1"
                                      />
                                      <label
                                        className="form-check-label"
                                        htmlFor="flexRadioDefault1"
                                        style={{ fontWeight: 'normal', fontSize: '14px' }}
                                      >
                                        Active
                                      </label>
                                    </div>
                                    <div className="form-check">
                                      <input
                                        className="form-check-input"
                                        type="radio"
                                        name="flexRadioDefault"
                                        id="flexRadioDefault2"
                                        defaultChecked
                                      />
                                      <label
                                        className="form-check-label"
                                        htmlFor="flexRadioDefault2"
                                        style={{ fontWeight: 'normal', fontSize: '14px' }}
                                      >
                                        Inactive
                                      </label>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className='col-lg-6 col-md-6 col-12'>
                                <div className="info-inner">
                                  <label
                                    htmlFor="ID"
                                    className="form-label d-flex align-items-center gap-1"
                                  >
                                    ID
                                    <Tooltip content="ID">
                                      <Info size={16} className="info-icon" />
                                    </Tooltip>
                                  </label>

                                  {/* <input
                                    type="text"
                                    className="form-control common-input-all"
                                    id="ID"
                                    placeholder="Device"
                                  /> */}
                                    <CharacterLimitedTextarea
                                                id="ID"
                                                placeholder="Device"
                                                
                                              
                                                onChange={handleChangeWithDirty}
                                                maxLength={50}
                                                counterPosition="end" // or "below" if you prefer below the input
                                                />
                                </div>
                              </div>

                            </div>
                            {/* ─── ROW 2: Compatibility ─────────────────────────────────────── */}
                            <div className='row gappingcls-added'>
                              <div className='col-lg-6 col-md-6 col-12'>
                                <div className="info-inner" ref={compatibilityRef} style={{ position: 'relative' }}>
                                  <label className="form-label d-flex align-items-center gap-2">
                                    Compatibility
                                    <Tooltip content="Select one or more Compatibilitys for this employee">
                                      <Info size={16} className="info-icon" />
                                    </Tooltip>
                                  </label>

                                  {/* CLOSED VIEW: tags + count + arrow */}
                                  <div
                                    className="select-box form-control common-input-all"
                                    onClick={toggleCompatibility}
                                    style={{
                                      padding: '0.5rem',
                                      minHeight: '40px',
                                      display: 'flex',
                                      alignItems: 'center',
                                      flexWrap: 'wrap',
                                      position: 'relative',
                                      cursor: 'pointer',
                                    }}
                                  >
                                    {selectedCompatibility.length > 0 ? (
                                      selectedCompatibility.map((g) => (
                                        <span
                                          key={g.id}
                                          className="tag"
                                          style={{
                                            backgroundColor: '#FFEB00',
                                            color: '#212529',
                                            borderRadius: '16px',
                                            padding: '4px 8px',
                                            margin: '2px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            fontSize: '12px',
                                            fontWeight: '600',
                                            lineHeight: 'normal',
                                          }}
                                        >
                                          {g.role_name}
                                          <button
                                            type="button"
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              removeCompatibility(g.id);
                                            }}
                                            style={{
                                              background: 'none',
                                              border: 'none',
                                              marginLeft: '20px',
                                              cursor: 'pointer',
                                              fontSize: '16px',
                                              padding: '0',
                                              lineHeight: '14px',
                                            }}
                                          >
                                            <X size={14} strokeWidth={3} />
                                          </button>
                                        </span>
                                      ))
                                    ) : (
                                      <span style={{ color: '#999', fontSize: '0.9rem' }}>
                                        Select Compatibility
                                      </span>
                                    )}

                                    {/* Selected count + Arrow (only right side aligned) */}
                                    <span
                                      style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        marginLeft: 'auto',
                                        gap: '0.25rem',
                                        fontSize: '0.8rem',
                                        color: '#666',
                                      }}
                                    >
                                      {selectedCompatibility.length > 0 && (
                                        <span>{selectedCompatibility.length} selected</span>
                                      )}
                                      <ChevronDown
                                        size={16}
                                        style={{
                                          transform: isCompatibilityOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                                          transition: 'transform 0.2s',
                                          userSelect: 'none',
                                        }}
                                      />
                                    </span>
                                  </div>

                                  {/* DROPDOWN PANEL */}
                                  {isCompatibilityOpen && (
                                    <div
                                      className="options-container"
                                      style={{
                                        border: '1px solid #6c757d',
                                        borderRadius: '8px',
                                        marginTop: '4px',
                                        maxHeight: '270px',
                                        overflowY: 'auto',
                                        background: '#fff',
                                        position: 'absolute',
                                        top: '100%',
                                        left: 0,
                                        zIndex: 1000,
                                        width: '100%',
                                        boxShadow: '0px 1px 4px 0px #0000001A',
                                      }}
                                      onWheel={(e) => e.preventDefault()}
                                    >
                                      {/* Search input with icon */}
                                      <div style={{ padding: '0.5rem', position: 'relative' }}>
                                        <Search
                                          size={18}
                                          style={{
                                            position: 'absolute',
                                            top: '50%',
                                            left: '18px',
                                            transform: 'translateY(-50%)',
                                            color: '#6C757D',
                                            pointerEvents: 'none',
                                          }}
                                        />
                                        <input
                                          type="text"
                                          className="search-input select-box form-control common-input-all"
                                          placeholder="Search..."
                                          value={compatibilitySearch}
                                          onChange={(e) => setCompatibilitySearch(e.target.value)}
                                          style={{
                                            width: '100%',
                                            padding: '0.5rem 0.5rem 0.5rem 2rem',
                                            fontSize: '0.9rem',
                                            outline: 'none',
                                          }}
                                        />
                                      </div>

                                      {/* Options list */}
                                      <ul
                                        className="options-list custom-check"
                                        style={{
                                          listStyle: 'none',
                                          margin: 0,
                                          padding: '1.25rem',
                                        }}
                                      >
                                        {allCompatibility.map((g) => (
                                          <li key={g.id} style={{ marginBottom: '0.5rem' }}>
                                            <label
                                              className="option-item"
                                              style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                cursor: 'pointer',
                                                fontSize: '0.9rem',
                                                fontWeight: 'normal',
                                              }}
                                            >
                                              <input
                                                type="checkbox"
                                                className="form-check-input"
                                                checked={
                                                  selectedCompatibility.findIndex(
                                                    (item) => item.id === g.id
                                                  ) > -1
                                                }
                                                onChange={() => handleCompatibilityCheckbox(g)}
                                                style={{ marginRight: '8px' }}
                                              />
                                              {g.role_name}
                                            </label>
                                          </li>
                                        ))}

                                        {filteredCompatibility.length === 0 && (
                                          <li style={{ color: '#999', textAlign: 'center', fontSize: '0.9rem' }}>
                                            No Compatibility found
                                          </li>
                                        )}
                                      </ul>
                                    </div>
                                  )}
                                </div>
                              </div>


                            </div>
                            {/* ─── ROW 3: Images  ────────────── */}
                            <div className="row gappingcls-added">
                              <div className="col-12">
                                <div className="info-inner">
                                  <label className="form-label d-flex align-items-center gap-2">
                                    Images
                                    <Tooltip content="Upload your spu images">
                                      <Info size={16} className="info-icon" />
                                    </Tooltip>
                                  </label>

                                  {/* Dropzone */}
                                  <div
                                    className="upload-container"
                                    onClick={handleBrowseClick}
                                    onDragOver={e => e.preventDefault()}
                                    onDragEnter={() => setIsDragging(true)}
                                    onDragLeave={() => setIsDragging(false)}
                                    onDrop={handleDrop}
                                    style={{
                                      border: '2px dashed #ccc',
                                      borderRadius: 4,
                                      padding: '3rem 1.5rem',
                                      textAlign: 'center',
                                      cursor: 'pointer',
                                      backgroundColor: isDragging ? '#CFE2FF' : '#fff', // Drag highlight
                                      borderColor: isDragging ? '#0D6EFD' : '#ccc', // Drag highlight
                                      transition: 'background-color 0.3s ease',
                                    }}
                                  >
                                    <CloudUpload size={32} />
                                    <p style={{ margin: 0, color: '#555', fontSize: '0.9rem' }}>
                                      Drag your image here or{' '}
                                      <span style={{ color: '#007bff', textDecoration: 'underline' }}>
                                        Browse
                                      </span>
                                    </p>
                                    <input
                                      type="file"
                                      accept="image/*"
                                      multiple
                                      ref={fileInputRef}
                                      style={{ display: 'none' }}
                                      onChange={handleImageChange}
                                    />
                                  </div>

                                  {/* Uploaded Images */}
                                  {uploadedImages.length > 0 && (
                                    <div className="uploaded-images mt-3">
                                      <p className='mb-3'>
                                        {uploadedImages.length} Image
                                        {uploadedImages.length > 1 ? 's' : ''} uploaded
                                      </p>

                                      <ReactSortable
                                        list={uploadedImages}
                                        setList={setUploadedImages}
                                        handle=".drag-handle"
                                        tag="div"
                                        className="row g-2"
                                        chosenClass="is-dragging"    // ← this class goes on the dragged item
                                      >
                                        {uploadedImages.map(img => (
                                          <div className="col-md-4 col-sm-6" key={img.id}>
                                            <div className="d-flex align-items-center justify-content-between p-2 border rounded" style={{ boxShadow: '0px 1px 4px 0px #0000001A' }}>
                                              <div className="d-flex align-items-center gap-2">
                                                <X size={18} onClick={() => handleRemove(img.id)} className="cursor-pointer" style={{ flex: 'none' }} />
                                                <img
                                                  src={img.preview}
                                                  alt="preview"
                                                  style={{
                                                    width: 40,
                                                    height: 40,
                                                    objectFit: 'cover',
                                                    borderRadius: 4,
                                                  }}
                                                />
                                                <div>
                                                  <div style={{ fontSize: '0.85rem', fontWeight: 500, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '150px', color: '#6C757D' }}>
                                                    {img.file.name}
                                                  </div>
                                                  <div style={{ fontSize: '0.75rem', color: '#6C757D' }}>{formatSize(img.file.size)}</div>
                                                </div>
                                              </div>
                                              <Menu
                                                size={16}
                                                className="drag-handle text-muted"
                                                style={{ cursor: 'grab', flex: 'none' }}
                                              />
                                            </div>
                                          </div>
                                        ))}
                                      </ReactSortable>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="row gappingcls-added" style={{ marginTop: '20px' }}>
                            <div className="col-12">
                              <div className="info-inner">
                                <label className="form-label d-flex align-items-center gap-2">
                                  Customised Info <Tooltip content="Customised Info">
                                    <Info size={16} className="info-icon" />
                                  </Tooltip>
                                </label>
                                <div className="info-content d-block entities-tab" style={{ padding: '0' }}>
                                  <div style={{ padding: '20px', boxShadow: '0px 1px 4px #0000001A', borderRadius: '12px' }}>
                                    {rows.length === 0 && showMissingSku && (
                                      <div
                                        className="d-flex align-items-center justify-content-between"
                                        role="alert"
                                        style={{
                                          boxShadow: '0px 4px 10px 0px #0000001F',
                                          padding: '15px 10px',
                                          borderRadius: '12px',
                                          border: '1px solid #DC3545',
                                          backgroundColor: '#F8D7DA',
                                          color: '#58151C',
                                          fontSize: '12px',
                                          position: 'fixed',
                                          top: '10px',
                                          width: 'calc(100% - 20px)',
                                          maxWidth: '640px',
                                          left: '50%',
                                          transform: 'translateX(-50%)',
                                          zIndex: 2000
                                        }}
                                      >
                                        <div className="d-flex align-items-center">
                                          <Info className="me-2" />
                                          <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                            <strong>Missing SKU:</strong> Please add a default SKU to save your SPU, or proceed to the next step
                                          </div>
                                        </div>

                                        <X
                                          size={16}
                                          style={{ cursor: 'pointer' }}
                                          onClick={() => setShowMissingSku(false)}
                                        />
                                      </div>
                                    )}


                                    <div className="table-wrapper" style={{ position: 'relative', overflowX: 'auto' }}>
                                      <table className="entities-table tab-table w-100">
                                        <thead>
                                          <tr>
                                            <th />
                                            <th><span>Level <ChevronsUpDown size={12} /></span></th>
                                            <th><span>Field Name <ChevronsUpDown size={12} /></span></th>
                                            <th><span>Field Type <ChevronsUpDown size={12} /></span></th>
                                            <th><span>Field Value <ChevronsUpDown size={12} /></span></th>
                                            <th /></tr>
                                        </thead>
                                        <ReactSortable list={rows} setList={setRows} handle=".drag-handle" tag="tbody">
                                          {rows.map((r, idx) => {
                                            if (!rowRefs.current[r.id]) rowRefs.current[r.id] = React.createRef();
                                            const ref = rowRefs.current[r.id];
                                            return <EntityRow key={r.id} refNode={ref} rowState={r} index={idx}
                                              deleteRow={deleteRow} updateRowBulk={updateRowBulk} />;
                                          })}
                                        </ReactSortable>
                                      </table>
                                    </div>
                                    <div className="edit-organisation-info" style={{ display: 'flex', marginTop: '20px', marginBottom: '0', boxShadow: 'none', padding: '0' }}>
                                      <button onClick={addRow} className="dark-button">Add Fields</button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </>}
                        {activeTab === "black-iphone-16-pro-max" && <div>Black content</div>}
                        {/* ... */}
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          )}
          {activeTab2 === 'sku-code' && (
            <div className="tab-content" id="sku-code-content">
              <div className="info-section">
                <div className="info-section">
                  {/* ─── SKU Code CARD ─────────────────────────────────────────── */}
                  <div className="info-card new-info-overflow-auto main-company-body-inner">
                    <div className="info-header"><h4 className="info-title">SKU Code</h4></div>
                    <div className="info-content d-block entities-tab">
                      <div className="table-wrapper" style={{ position: 'relative', overflowX: 'auto' }}>
                        <table className="entities-table tab-table w-100">
                          <thead>
                            <tr>
                              <th><span>SKU Spec <ChevronsUpDown size={12} /></span></th>
                              <th><span>Spec Name <ChevronsUpDown size={12} /></span></th>
                              <th><span>GTIN <ChevronsUpDown size={12} /></span></th>
                              <th><span>SKU Code <ChevronsUpDown size={12} /></span></th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>
                                <div style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  flexWrap: 'wrap',
                                  minHeight: '40px',
                                  gap: '10px',
                                  minWidth: '350px',
                                  maxWidth: '350px'
                                }}>
                                  <div>
                                    <span style={{
                                      color: '#212529',
                                      fontSize: '12px',
                                      lineHeight: '15px',
                                      fontWeight: '400',
                                      marginBottom: '5px',
                                      display: 'block',
                                    }}>
                                      Color
                                    </span>
                                    <span
                                      style={{
                                        backgroundColor: '#FFEB00',
                                        color: '#212529',
                                        borderRadius: '16px',
                                        padding: '4px 8px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        fontSize: '12px',
                                        fontWeight: '600',
                                        lineHeight: '17px',
                                      }}
                                    >White Titanium
                                    </span>
                                  </div>
                                  <div>
                                    <span style={{
                                      color: '#212529',
                                      fontSize: '12px',
                                      lineHeight: '15px',
                                      fontWeight: '400',
                                      marginBottom: '5px',
                                      display: 'block',
                                    }}>
                                      Storage
                                    </span>
                                    <span
                                      style={{
                                        backgroundColor: '#FFEB00',
                                        color: '#212529',
                                        borderRadius: '16px',
                                        padding: '4px 8px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        fontSize: '12px',
                                        fontWeight: '600',
                                        lineHeight: '17px',
                                      }}
                                    >256GB
                                    </span>
                                  </div>
                                  <div>
                                    <span style={{
                                      color: '#212529',
                                      fontSize: '12px',
                                      lineHeight: '15px',
                                      fontWeight: '400',
                                      marginBottom: '5px',
                                      display: 'block',
                                    }}>
                                      Connectivity
                                    </span>
                                    <span
                                      style={{
                                        backgroundColor: '#FFEB00',
                                        color: '#212529',
                                        borderRadius: '16px',
                                        padding: '4px 8px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        fontSize: '12px',
                                        fontWeight: '600',
                                        lineHeight: '17px',
                                      }}
                                    >Wi‑Fi
                                    </span>
                                  </div>
                                </div>
                              </td>
                              <td><input type="text" style={{ minWidth: '200px', maxWidth: '200px' }} className="form-control common-input-all" placeholder="White-256GB-Wifi" /></td>
                              <td><input type="text" style={{ minWidth: '200px', maxWidth: '200px' }} className="form-control common-input-all" /></td>
                              <td><input type="text" style={{ minWidth: '200px', maxWidth: '200px' }} className="form-control common-input-all" placeholder="WHT256WF" /></td>
                            </tr>
                            <tr>
                              <td>
                                <div style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  flexWrap: 'wrap',
                                  minHeight: '40px',
                                  gap: '10px',
                                  minWidth: '350px',
                                  maxWidth: '350px'
                                }}>
                                  <div>
                                    <span style={{
                                      color: '#212529',
                                      fontSize: '12px',
                                      lineHeight: '15px',
                                      fontWeight: '400',
                                      marginBottom: '5px',
                                      display: 'block',
                                    }}>
                                      Color
                                    </span>
                                    <span
                                      style={{
                                        backgroundColor: '#FFEB00',
                                        color: '#212529',
                                        borderRadius: '16px',
                                        padding: '4px 8px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        fontSize: '12px',
                                        fontWeight: '600',
                                        lineHeight: '17px',
                                      }}
                                    >Black Titanium
                                    </span>
                                  </div>
                                  <div>
                                    <span style={{
                                      color: '#212529',
                                      fontSize: '12px',
                                      lineHeight: '15px',
                                      fontWeight: '400',
                                      marginBottom: '5px',
                                      display: 'block',
                                    }}>
                                      Storage
                                    </span>
                                    <span
                                      style={{
                                        backgroundColor: '#FFEB00',
                                        color: '#212529',
                                        borderRadius: '16px',
                                        padding: '4px 8px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        fontSize: '12px',
                                        fontWeight: '600',
                                        lineHeight: '17px',
                                      }}
                                    >256GB
                                    </span>
                                  </div>
                                  <div>
                                    <span style={{
                                      color: '#212529',
                                      fontSize: '12px',
                                      lineHeight: '15px',
                                      fontWeight: '400',
                                      marginBottom: '5px',
                                      display: 'block',
                                    }}>
                                      Connectivity
                                    </span>
                                    <span
                                      style={{
                                        backgroundColor: '#FFEB00',
                                        color: '#212529',
                                        borderRadius: '16px',
                                        padding: '4px 8px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        fontSize: '12px',
                                        fontWeight: '600',
                                        lineHeight: '17px',
                                      }}
                                    >Wi‑Fi
                                    </span>
                                  </div>
                                </div>
                              </td>
                              <td><input type="text" style={{ minWidth: '200px', maxWidth: '200px' }} className="form-control common-input-all" placeholder="White-256GB-Wifi" /></td>
                              <td><input type="text" style={{ minWidth: '200px', maxWidth: '200px' }} className="form-control common-input-all" /></td>
                              <td><input type="text" style={{ minWidth: '200px', maxWidth: '200px' }} className="form-control common-input-all" placeholder="WHT256WF" /></td>
                            </tr>
                            <tr>
                              <td>
                                <div style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  flexWrap: 'wrap',
                                  minHeight: '40px',
                                  gap: '10px',
                                  minWidth: '350px',
                                  maxWidth: '350px'
                                }}>
                                  <div>
                                    <span style={{
                                      color: '#212529',
                                      fontSize: '12px',
                                      lineHeight: '15px',
                                      fontWeight: '400',
                                      marginBottom: '5px',
                                      display: 'block',
                                    }}>
                                      Color
                                    </span>
                                    <span
                                      style={{
                                        backgroundColor: '#FFEB00',
                                        color: '#212529',
                                        borderRadius: '16px',
                                        padding: '4px 8px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        fontSize: '12px',
                                        fontWeight: '600',
                                        lineHeight: '17px',
                                      }}
                                    >Desert Titanium
                                    </span>
                                  </div>
                                  <div>
                                    <span style={{
                                      color: '#212529',
                                      fontSize: '12px',
                                      lineHeight: '15px',
                                      fontWeight: '400',
                                      marginBottom: '5px',
                                      display: 'block',
                                    }}>
                                      Storage
                                    </span>
                                    <span
                                      style={{
                                        backgroundColor: '#FFEB00',
                                        color: '#212529',
                                        borderRadius: '16px',
                                        padding: '4px 8px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        fontSize: '12px',
                                        fontWeight: '600',
                                        lineHeight: '17px',
                                      }}
                                    >256GB
                                    </span>
                                  </div>
                                  <div>
                                    <span style={{
                                      color: '#212529',
                                      fontSize: '12px',
                                      lineHeight: '15px',
                                      fontWeight: '400',
                                      marginBottom: '5px',
                                      display: 'block',
                                    }}>
                                      Connectivity
                                    </span>
                                    <span
                                      style={{
                                        backgroundColor: '#FFEB00',
                                        color: '#212529',
                                        borderRadius: '16px',
                                        padding: '4px 8px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        fontSize: '12px',
                                        fontWeight: '600',
                                        lineHeight: '17px',
                                      }}
                                    >Wi‑Fi
                                    </span>
                                  </div>
                                </div>
                              </td>
                              <td><input type="text" style={{ minWidth: '200px', maxWidth: '200px' }} className="form-control common-input-all" placeholder="White-256GB-Wifi" /></td>
                              <td><input type="text" style={{ minWidth: '200px', maxWidth: '200px' }} className="form-control common-input-all" /></td>
                              <td><input type="text" style={{ minWidth: '200px', maxWidth: '200px' }} className="form-control common-input-all" placeholder="WHT256WF" /></td>
                            </tr>
                            <tr>
                              <td>
                                <div style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  flexWrap: 'wrap',
                                  minHeight: '40px',
                                  gap: '10px',
                                  minWidth: '350px',
                                  maxWidth: '350px'
                                }}>
                                  <div>
                                    <span style={{
                                      color: '#212529',
                                      fontSize: '12px',
                                      lineHeight: '15px',
                                      fontWeight: '400',
                                      marginBottom: '5px',
                                      display: 'block',
                                    }}>
                                      Color
                                    </span>
                                    <span
                                      style={{
                                        backgroundColor: '#FFEB00',
                                        color: '#212529',
                                        borderRadius: '16px',
                                        padding: '4px 8px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        fontSize: '12px',
                                        fontWeight: '600',
                                        lineHeight: '17px',
                                      }}
                                    >Natural Titanium
                                    </span>
                                  </div>
                                  <div>
                                    <span style={{
                                      color: '#212529',
                                      fontSize: '12px',
                                      lineHeight: '15px',
                                      fontWeight: '400',
                                      marginBottom: '5px',
                                      display: 'block',
                                    }}>
                                      Storage
                                    </span>
                                    <span
                                      style={{
                                        backgroundColor: '#FFEB00',
                                        color: '#212529',
                                        borderRadius: '16px',
                                        padding: '4px 8px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        fontSize: '12px',
                                        fontWeight: '600',
                                        lineHeight: '17px',
                                      }}
                                    >256GB
                                    </span>
                                  </div>
                                  <div>
                                    <span style={{
                                      color: '#212529',
                                      fontSize: '12px',
                                      lineHeight: '15px',
                                      fontWeight: '400',
                                      marginBottom: '5px',
                                      display: 'block',
                                    }}>
                                      Connectivity
                                    </span>
                                    <span
                                      style={{
                                        backgroundColor: '#FFEB00',
                                        color: '#212529',
                                        borderRadius: '16px',
                                        padding: '4px 8px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        fontSize: '12px',
                                        fontWeight: '600',
                                        lineHeight: '17px',
                                      }}
                                    >Wi‑Fi
                                    </span>
                                  </div>
                                </div>
                              </td>
                              <td><input type="text" style={{ minWidth: '200px', maxWidth: '200px' }} className="form-control common-input-all" placeholder="White-256GB-Wifi" /></td>
                              <td><input type="text" style={{ minWidth: '200px', maxWidth: '200px' }} className="form-control common-input-all" /></td>
                              <td><input type="text" style={{ minWidth: '200px', maxWidth: '200px' }} className="form-control common-input-all" placeholder="WHT256WF" /></td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>


      </div > {/* end of company-body */}
    </>
  );
}

function EntityRow({ refNode, rowState: r, index: idx, deleteRow, updateRowBulk }) {
  const typeRef = useRef(null);
  const valueRef = useRef(null);
  const [portalStyle, setPortalStyle] = useState({});
  const [typePortalStyle, setTypePortalStyle] = useState({});

  // Position Field Value portal
  useEffect(() => {
    if (r.isOpen && valueRef.current) {
      const rect = valueRef.current.getBoundingClientRect();
      setPortalStyle({
        position: 'absolute',
        top: rect.bottom + window.scrollY,
        left: rect.left + window.scrollX,
        width: rect.width,
        background: '#fff',
        border: '1px solid #6c757d',
        borderRadius: '8px',
        overflow: 'visible',
        zIndex: 2000,
      });
    }
  }, [r.isOpen, r.opts, r.search]);


  // Position Field Type portal
  useEffect(() => {
    if (r.typeOpen && typeRef.current) {
      const rect = typeRef.current.getBoundingClientRect();
      setTypePortalStyle({
        position: 'absolute',
        top: rect.bottom + window.scrollY,
        left: rect.left + window.scrollX,
        width: rect.width,
        background: '#fff',
        border: '1px solid #6c757d',
        borderRadius: '8px',
        zIndex: 2000,
      });
    }
  }, [r.typeOpen]);

  return (
    <tr ref={refNode} style={{ position: (r.isOpen || r.typeOpen || r.refMenuOpen) ? 'relative' : 'static', zIndex: (r.isOpen || r.typeOpen || r.refMenuOpen) ? 1000 : 'auto' }}>
      <td><button className="btn p-0" onClick={() => deleteRow(r.id)} style={{ boxShadow: 'none' }}><Trash2 size={18} /></button></td>
      <td>{idx + 1}</td>
      <td style={{ minWidth: '200px', maxWidth: '200px' }}><input className="form-control common-input-all" value={r.fieldName} onChange={e => updateRowBulk(r.id, { fieldName: e.target.value })} /></td>
      {/* FIELD TYPE unchanged */}
      <td style={{ position: 'relative', minWidth: '200px', maxWidth: '200px' }}>
        <div
          ref={typeRef}
          className="form-select new-form-select-cls"
          onClick={() => updateRowBulk(r.id, { typeOpen: !r.typeOpen })}
          style={{
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '0.5rem',
            minHeight: '40px',
            background: 'none',
          }}
        >
          <span style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
            {r.fieldType === 'Text' ? (
              'Text'
            ) : (
              <>
                Reference
                <span className="pill">{r.refChild}</span>
              </>
            )}
          </span>
          <ChevronDown size={16} style={{ transform: r.typeOpen ? 'rotate(180deg)' : 'rotate(0)' }} />
        </div>

        {r.typeOpen && (
          <OptionPortal style={typePortalStyle}>
            <ul
              className="custom-check"
              style={{
                margin: 0,
                padding: 0,
                listStyle: 'none',
                overflow: 'visible',
                position: 'relative',
              }}
            >
              {/* TEXT OPTION */}
              <li
                style={{
                  padding: '0.5rem 1rem',
                  cursor: 'pointer',
                  fontFamily: 'Montserrat',
                  fontSize: '14px',
                }}
                onClick={() =>
                  updateRowBulk(r.id, {
                    fieldType: 'Text',
                    refChild: '',
                    value: '',
                    opts: [],
                    typeOpen: false,
                  })
                }
              >
                Text
              </li>

              {/* REFERENCE OPTION */}
              {/* <li style={{ borderTop: '1px solid #eee', position: 'relative' }}>
                <div
                  style={{
                    padding: '0.5rem 1rem',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    cursor: 'pointer',
                    backgroundColor: r.refMenuOpen ? '#FFFEF0' : '#FFFEF0',
                    fontFamily: 'Montserrat',
                    fontSize: '14px',
                    borderRadius: '0px 0px 8px 8px',
                  }}
                  onClick={() => updateRowBulk(r.id, { refMenuOpen: !r.refMenuOpen })}
                >
                  Reference
                  <ChevronRight size={14} style={{ transform: r.refMenuOpen ? 'rotate(90deg)' : 'rotate(0)' }} />
                </div>

                {r.refMenuOpen && (
                  <ul
                    style={{
                      listStyle: 'none',
                      margin: 0,
                      padding: '0.5rem 0',
                      position: 'absolute',
                      left: '100%',
                      top: 0,
                      background: 'white',
                      border: '1px solid #eee',
                      borderRadius: '4px',
                      boxShadow: '0 4px 8px rgba(0,0,0,0.05)',
                      zIndex: 10,
                    }}
                  >
                    {REFERENCE_CHILDREN.map((opt) => (
                      <li
                        key={opt}
                        style={{
                          padding: '0.5rem 1.5rem',
                          cursor: 'pointer',
                          fontFamily: 'Montserrat',
                          fontSize: '14px',
                          backgroundColor: r.refChild === opt ? '#FFFEF0' : 'transparent',
                        }}
                        onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#FFFEF0')}
                        onMouseLeave={(e) =>
                          (e.currentTarget.style.backgroundColor = r.refChild === opt ? '#FFFEF0' : 'transparent')
                        }
                        onClick={() =>
                          updateRowBulk(r.id, {
                            fieldType: 'Reference',
                            refChild: opt,
                            isOpen: true,
                            typeOpen: false,
                            refMenuOpen: false,
                            opts: [],
                          })
                        }
                      >
                        {opt}
                      </li>
                    ))}
                  </ul>
                )}
              </li> */}
            </ul>
          </OptionPortal>
        )}
      </td>
      {/* FIELD VALUE with portal */}
      <td style={{ position: 'relative', minWidth: '200px', maxWidth: '200px' }}>
        {r.fieldType === 'Text' ? (
          <input
            className="form-control common-input-all"
            value={r.value}
            onChange={(e) => updateRowBulk(r.id, { value: e.target.value })}
          />
        ) : (
          <>
            <div
              ref={valueRef}
              className="select-box form-control common-input-all"
              onClick={() => updateRowBulk(r.id, { isOpen: !r.isOpen })}
              style={{
                padding: '0.5rem',
                display: 'flex',
                alignItems: 'center',
                flexWrap: 'wrap',
                cursor: 'pointer',
                minHeight: '40px',
              }}
            >
              {r.opts.length > 0 ? (
                <>
                  <span
                    className="tag"
                    style={{
                      fontSize: '14px',
                      fontWeight: '400',
                      backgroundColor: 'transparent',
                      color: '#6C757D',
                      maxWidth: '100%',
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                    }}
                  >
                    {r.opts[0].label}
                  </span>
                  {r.opts.length > 1 && (
                    <span style={{ width: '24px', height: '24px', borderRadius: '50%', marginLeft: '5px', fontSize: '12px', fontWeight: '600', backgroundColor: '#212529', color: '#fff', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                      +{r.opts.length - 1}
                    </span>
                  )}
                </>
              ) : (
                <span style={{ color: '#999' }}>Select {r.refChild}</span>
              )}
              <ChevronDown size={16} style={{ marginLeft: 'auto', transform: r.isOpen ? 'rotate(180deg)' : 'rotate(0)' }} />
            </div>

            {r.isOpen && (
              <OptionPortal style={portalStyle}>
                {/* SEARCH FIELD */}
                <div style={{ padding: '0.5rem', position: 'relative' }}>
                  <Search
                    size={18}
                    style={{
                      position: 'absolute',
                      top: '50%',
                      left: '18px',
                      transform: 'translateY(-50%)',
                      color: '#6c757d',
                    }}
                  />
                  <input
                    type="text"
                    className="form-control common-input-all search-input select-box"
                    placeholder="Search..."
                    value={r.search}
                    onChange={(e) => updateRowBulk(r.id, { search: e.target.value })}
                    style={{ paddingLeft: '2rem' }}
                  />
                </div>

                {/* SEARCH RESULTS HEADER */}
                <div style={{ padding: '0 15px 16px', fontSize: '12px', fontWeight: '400', color: '#6C757D' }}>
                  Search Results
                </div>

                {/* SEARCH RESULTS */}
                <ul
                  className="options-list custom-check info-inner"
                  style={{ listStyle: 'none', margin: 0, padding: '0 1.25rem 0.75rem' }}
                >
                  {REFERENCE_OPTIONS[r.refChild]
                    .filter(opt => opt.label.toLowerCase().includes(r.search.toLowerCase()))
                    .filter(opt => !r.opts.some(o => o.value === opt.value))
                    .map(opt => (
                      <li key={opt.value} style={{ marginBottom: '8px' }}>
                        <label
                          className="option-item"
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            cursor: 'pointer',
                            fontSize: '0.9rem',
                            fontWeight: '400',
                            lineHeight: '1.4',
                          }}
                        >
                          <input
                            type="checkbox"
                            className="form-check-input"
                            style={{ marginRight: '8px', marginTop: '2px', cursor: 'pointer' }}
                            checked={false}
                            onChange={() => updateRowBulk(r.id, { opts: [...r.opts, opt] })}
                          />
                          {renderLabel(opt.label)}
                        </label>
                      </li>
                    ))}

                </ul>

                {/* SELECTED RESULTS HEADER */}
                {r.opts.length > 0 && (
                  <div style={{ padding: '0 15px 16px', fontSize: '12px', lineHeight: '15px', fontWeight: '400', color: '#6C757D' }}>
                    Selected
                  </div>
                )}

                {/* SELECTED OPTIONS */}
                {r.opts.length > 0 && (
                  <ul
                    className="selected-list custom-check info-inner"
                    style={{ listStyle: 'none', margin: 0, padding: '0 1.25rem 1rem' }}
                  >
                    {r.opts.map(opt => (
                      <li key={opt.value} style={{ marginBottom: '0.5rem' }}>
                        <label
                          className="option-item"
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            cursor: 'pointer',
                            fontSize: '0.9rem',
                            fontWeight: '400',
                            lineHeight: '1.4',
                          }}
                        >
                          <input
                            type="checkbox"
                            className="form-check-input"
                            style={{ marginRight: '8px', marginTop: '2px', cursor: 'pointer' }}
                            checked={true}
                            onChange={() =>
                              updateRowBulk(r.id, {
                                opts: r.opts.filter(o => o.value !== opt.value),
                              })
                            }
                          />
                          {renderLabel(opt.label)}
                        </label>
                      </li>
                    ))}

                  </ul>
                )}
              </OptionPortal>
            )}
          </>
        )}
      </td>

      <td className="drag-handle" style={{ cursor: 'grab' }}><Menu size={18} /></td>
    </tr>
  );
}
function VariationRow({ refNode, rowState: r, index: idx, deleteRow, updateRow, skuAttributes, skuAttributeOptions, rows2 }) {
  const valueRef = useRef(null);
  const [portalStyle, setPortalStyle] = useState({});

  useEffect(() => {
    if (r.isOpen && valueRef.current) {
      const rect = valueRef.current.getBoundingClientRect();
      setPortalStyle({
        position: 'absolute',
        top: rect.bottom + window.scrollY,
        left: rect.left + window.scrollX,
        width: rect.width,
        background: '#fff',
        border: '1px solid #6c757d',
        borderRadius: '8px',
        overflow: 'visible',
        zIndex: 2000,
      });
    }
  }, [r.isOpen]);

  // Get available attributes, excluding those selected in other rows
  const getAvailableAttributes = () => {
    const selectedAttributeIds = rows2
      .filter(row => row.id !== r.id && row.fieldName)
      .map(row => row.fieldName);
    const attributes = skuAttributes
      .filter(attr => !selectedAttributeIds.includes(attr.attribute_id.toString()))
      .map(attr => ({
        label: attr.attribute_name,
        value: attr.attribute_id.toString(),
      }));
    console.log('selectedAttributeIds',selectedAttributeIds)
    console.log('getAvailableAttributes:', attributes);
    return attributes;
  };

  // Get available options for the selected attribute, excluding those selected in the current row
  const getAttributeOptions = () => {
    if (!r.fieldName) return [];
    const options = skuAttributeOptions
      .filter(opt => opt.attribute.toString() === r.fieldName && opt.option_value)
      .map(opt => ({
        label: opt.option_value,
        value: opt.option_id.toString(),
      }))
      .filter(opt => !r.opts.some(selected => selected.value === opt.value));
    console.log('getAttributeOptions: fieldName', r.fieldName, 'options', options);
    return options;
  };

  return (
    <tr
      ref={refNode}
      style={{
        position: r.isOpen ? 'relative' : 'static',
        zIndex: r.isOpen ? 1000 : 'auto',
      }}
    >
      <td className="drag-handle">
        <Menu size={16} style={{ cursor: 'grab' }} />
      </td>
      <td>{idx + 1}</td>
      <td style={{ minWidth: '200px', maxWidth: '200px' }}>
        <select
          className="form-select new-form-select-cls"
          value={r.fieldName || ''}
          onChange={e => updateRow(r.id, { fieldName: e.target.value, opts: [], search: '' })}
        >
          <option value="">Select Variation</option>
          {getAvailableAttributes().map(attr => (
            <option key={attr.value} value={attr.value}>
              {attr.label}
            </option>
          ))}
        </select>
      </td>
      <td style={{ position: 'relative', minWidth: '200px', maxWidth: '600px' }}>
        <div
          ref={valueRef}
          className="select-box form-control common-input-all"
          onClick={() => updateRow(r.id, { isOpen: !r.isOpen })}
          style={{
            padding: '0.5rem',
            minHeight: '40px',
            display: 'flex',
            alignItems: 'center',
            flexWrap: 'wrap',
            cursor: 'pointer',
          }}
        >
          {r.opts.length ? (
            r.opts.map(opt => (
              <span
                key={opt.value}
                className="tag"
                style={{
                  backgroundColor: '#FFEB00',
                  color: '#212529',
                  borderRadius: '16px',
                  padding: '4px 8px',
                  margin: '2px',
                  display: 'flex',
                  alignItems: 'center',
                  fontSize: '12px',
                  fontWeight: '600',
                }}
              >
                {opt.label || 'Unnamed Option'}
                <button
                  type="button"
                  style={{ background: 'none', border: 'none', marginLeft: '8px', cursor: 'pointer' }}
                  onClick={e => {
                    e.stopPropagation();
                    updateRow(r.id, { opts: r.opts.filter(o => o.value !== opt.value) });
                  }}
                >
                  <X size={14} strokeWidth={3} />
                </button>
              </span>
            ))
          ) : (
            <span style={{ color: '#999' }}>Select values...</span>
          )}
          <ChevronDown
            size={16}
            style={{ marginLeft: 'auto', transform: r.isOpen ? 'rotate(180deg)' : 'rotate(0)' }}
          />
        </div>
        {r.isOpen && (
          <OptionPortal style={portalStyle}>
            <div style={{ padding: '0.5rem', position: 'relative' }}>
              <Search
                size={18}
                style={{ position: 'absolute', top: '50%', left: '18px', transform: 'translateY(-50%)', color: '#6c757d' }}
              />
              <input
                type="text"
                className="form-control common-input-all search-input select-box"
                placeholder="Search..."
                value={r.search || ''}
                onChange={e => updateRow(r.id, { search: e.target.value })}
                style={{ paddingLeft: '2rem' }}
              />
            </div>
            <ul className="options-list custom-check info-inner" style={{ listStyle: 'none', margin: 0, padding: '1.25rem' }}>
              {getAttributeOptions().length > 0 ? (
                getAttributeOptions()
                  .filter(o => o.label && (r.search ? o.label.toLowerCase().includes(r.search.toLowerCase()) : true))
                  .map(opt => (
                    <li key={opt.value} style={{ marginBottom: '0.5rem' }}>
                      <label
                        className="option-item"
                        style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', fontSize: '0.9rem', fontWeight: '400' }}
                      >
                        <input
                          type="checkbox"
                          className="form-check-input"
                          style={{ marginRight: '8px' }}
                          checked={r.opts.some(o => o.value === opt.value)}
                          onChange={() => {
                            const exists = r.opts.some(o => o.value === opt.value);
                            updateRow(r.id, {
                              opts: exists ? r.opts.filter(o => o.value !== opt.value) : [...r.opts, opt],
                            });
                          }}
                        />
                        {opt.label}
                      </label>
                    </li>
                  ))
              ) : (
                <li style={{ color: '#999', textAlign: 'center', fontSize: '0.9rem' }}>
                  No options available
                </li>
              )}
            </ul>
          </OptionPortal>
        )}
      </td>
      <td>
        <Trash2
          size={16}
          className="cursor-pointer"
          onClick={() => deleteRow(r.id)}
          style={{ color: 'red' }}
        />
      </td>
    </tr>
  );
}
function ConfigRow({ refNode, rowState: r, index: idx, deleteRow, updateRow }) {
  const valueRef = useRef(null);
  const [portalStyle, setPortalStyle] = useState({});

  useEffect(() => {
    if (r.isOpen && valueRef.current) {
      const rect = valueRef.current.getBoundingClientRect();
      setPortalStyle({
        position: 'absolute',
        top: rect.bottom + window.scrollY,
        left: rect.left + window.scrollX,
        width: rect.width,
        background: '#fff',
        border: '1px solid #6c757d',
        borderRadius: '8px',
        padding: '1rem',
        zIndex: 2000,
      });
    }
  }, [r.isOpen, r.opts]);

  const toggleOption = (group, option) => {
    const key = `${group}:${option}`;
    const exists = r.opts.includes(key);
    updateRow(r.id, {
      opts: exists ? r.opts.filter(o => o !== key) : [...r.opts, key],
    });
  };

  return (
    <tr ref={refNode} style={{ position: r.isOpen ? 'relative' : 'static', zIndex: r.isOpen ? 1000 : 'auto' }}>
      <td>
        <button className="btn p-0" onClick={() => deleteRow(r.id)} style={{ boxShadow: 'none' }}>
          <Trash2 size={18} />
        </button>
      </td>
      <td>{idx + 1}</td>
      <td style={{ minWidth: '200px', maxWidth: '200px' }}>
        <input
          className="form-control common-input-all"
          value={r.fieldName}
          onChange={e => updateRow(r.id, { fieldName: e.target.value })}
        />
      </td>
      <td style={{ position: 'relative', minWidth: '300px', maxWidth: '300px' }}>
        <div
          ref={valueRef}
          className="select-box form-control common-input-all"
          onClick={() => updateRow(r.id, { isOpen: !r.isOpen })}
          style={{ cursor: 'pointer', minHeight: '40px', padding: '0.5rem', display: 'flex', flexWrap: 'wrap', gap: '4px' }}
        >
          {r.opts.length ? r.opts.map(val => {
            const [grp, opt] = val.split(':');
            return (
              <span key={val} className="tag" style={{ backgroundColor: '#FFEB00', color: '#212529', borderRadius: '16px', padding: '4px 8px', fontSize: '12px', fontWeight: '600', display: 'flex', alignItems: 'center', gap: '4px' }}>
                {opt}
                <button type="button" style={{ background: 'none', border: 'none', cursor: 'pointer' }} onClick={e => { e.stopPropagation(); toggleOption(grp, opt); }}>
                  <X size={14} strokeWidth={3} />
                </button>
              </span>
            );
          }) : <span style={{ color: '#999' }}>Select options…</span>}
          <ChevronDown size={16} style={{ marginLeft: 'auto', transform: r.isOpen ? 'rotate(180deg)' : 'rotate(0)' }} />
        </div>

        {r.isOpen && (
          <OptionPortal style={portalStyle}>
            {Object.entries(CONFIG_GROUPS).map(([group, opts]) => (
              <div key={group} style={{ marginBottom: '1rem' }}>
                <strong style={{ display: 'block', marginBottom: '0.5rem', fontSize: '14px', fontWeight: '600', color: '#6C757D' }}>{group}</strong>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                  {opts.map(opt => {
                    const key = `${group}:${opt}`;
                    const selected = r.opts.includes(key);
                    return (
                      <span
                        key={key}
                        onClick={() => toggleOption(group, opt)}
                        style={{ padding: '4px 8px', borderRadius: '16px', cursor: 'pointer', fontSize: '12px', fontWeight: '600', backgroundColor: selected ? '#FFEB00' : 'transparent', border: '1px solid #FFEB00', color: selected ? '#212529' : '#212529' }}
                      >
                        {opt}
                      </span>
                    );
                  })}
                </div>
              </div>
            ))}
          </OptionPortal>
        )}
      </td>
      <td className="drag-handle" style={{ cursor: 'grab' }}><Menu size={18} /></td>
    </tr>
  );
}
